import React from 'react';
import { Check, X } from 'lucide-react';

const rows = [
  ['Time to first qualified meeting', '14–21 days', '60–120 days', 'text', 'text'],
  ['Setup fee', 'One-time, transparent', 'Often bundled, opaque', 'text', 'text'],
  ['Managed deliverability stack', '', '', 'check', 'x'],
  ['Multi-channel (email + LinkedIn + phone)', '', 'Email only', 'check', 'text'],
  ['Human-grade personalization at scale', '', 'Templates only', 'check', 'text'],
  ['Weekly strategy + optimization calls', '', '', 'check', 'x'],
  ['Performance-aligned pricing available', '', '', 'check', 'x'],
  ['Contract length', 'Rolling, cancel anytime', '6–12 months', 'text', 'text'],
];

function Cell({ kind, value, muted }) {
  if (kind === 'check') return <div className={muted ? 'v muted' : 'v'}><Check size={20} className="check-cyan" style={{ display: 'block', margin: '0 auto' }}/></div>;
  if (kind === 'x') return <div className={muted ? 'v muted' : 'v'}><X size={20} className="x-dim" style={{ display: 'block', margin: '0 auto' }}/></div>;
  return <div className={muted ? 'v muted' : 'v'}>{value}</div>;
}

export default function Compare() {
  return (
    <section>
      <div className="container-x">
        <div className="section-intro">
          <span className="eyebrow reveal">Why switch</span>
          <h2 className="section-heading reveal reveal-delay-1" style={{ marginTop: 24 }}>
            JustICP vs. <span className="text-gradient">the old way</span> of doing outbound.
          </h2>
          <p className="reveal reveal-delay-2">Same deliverable, qualified meetings on your calendar. Very different experience.</p>
        </div>
        <div className="compare reveal">
          <div className="compare-row compare-head">
            <div className="cat">Category</div>
            <div className="us">
              <div className="n">JustICP</div>
              <div className="s">AI-powered</div>
            </div>
            <div className="them">
              <div className="n">Typical agency</div>
              <div className="s">Legacy outbound</div>
            </div>
          </div>
          <div className="compare-body">
            {rows.map((r, i) => (
              <div key={i} className="compare-row">
                <div className="cat">{r[0]}</div>
                <Cell kind={r[3]} value={r[1]} />
                <Cell kind={r[4]} value={r[2]} muted />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
